class @App.Components.YoutubeVideoSeekTo
  constructor: (options) ->
    @player = options.player
    @selector = options.selector

    $(document).on 'click', @selector, (e) => @onSeekTo(e)

  onSeekTo: (e) =>
    @player.seekTo @seconds()
    @player.playVideo()

  seconds: =>
    $(@selector).data('seconds')
